import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LoginBroadcast.css';
import { EDUGATE_API_URL } from '../../config/serviceConfig';

const API_BASE_URL = EDUGATE_API_URL;

const LoginBroadcast = () => {
  const { t } = useTranslation();
  const [broadcasts, setBroadcasts] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);

  // 获取系统广播（最近30天，最多3条）
  useEffect(() => {
    fetchBroadcasts();
  }, []);

  const fetchBroadcasts = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/public/broadcasts?days=30`);
      const data = await response.json();
      
      if (data.code === 0 && data.data && data.data.length > 0) {
        // 只取前3条
        setBroadcasts(data.data.slice(0, 3));
      }
    } catch (error) {
      console.error('获取系统广播失败:', error);
    }
  };

  // 如果没有广播，不显示
  if (broadcasts.length === 0) return null;

  // 格式化时间
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('zh-CN', {
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const visibleBroadcasts = isExpanded ? broadcasts : broadcasts.slice(0, 1);

  return (
    <section className="login-broadcast-banner" aria-label={t('auth_broadcast_label')}>
      <div className="broadcast-heading">
        <span>{t('auth_broadcast_label')}</span>
        {broadcasts.length > 1 && (
          <button
            type="button"
            className="broadcast-toggle"
            onClick={() => setIsExpanded((expanded) => !expanded)}
            aria-expanded={isExpanded}
          >
            {isExpanded
              ? t('auth_broadcast_collapse')
              : t('auth_broadcast_expand', { count: broadcasts.length })}
          </button>
        )}
      </div>
      <div className="broadcast-list">
        {visibleBroadcasts.map((broadcast) => (
          <article className="broadcast-item" key={broadcast.id || broadcast.created_at}>
            <time>{formatTime(broadcast.created_at)}</time>
            <p><strong>{broadcast.title}</strong>{broadcast.content && `：${broadcast.content}`}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default LoginBroadcast;

